import { Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { round } from "../utils/mathsHelper";

export default function TotalCostDetailsTable({orderDetails}) {
  return (
    <TableContainer paddingTop="2rem" paddingBottom="6rem">
        <Table size="sm" variant="unstyled">
            <Thead>
                <Tr>
                    <Th width="70%">Description</Th>
                    <Th width="10%">Qty</Th>
                    <Th width="10%">Upfront</Th>
                    <Th width="10%">Annually</Th>
                </Tr>
            </Thead>
            <Tbody>
                {orderDetails.items && orderDetails.items.map((item) => (
                    <Tr key={item.description}>
                        <Td width="70%">{item.description}</Td>
                        <Td width="10%">{item.quantity}</Td>
                        <Td width="10%">${round(item.upfront,2)}</Td>
                        <Td width="10%">${round(item.annual, 2)}</Td>
                    </Tr>
                ))}
            </Tbody>
        </Table>
    </TableContainer>
  );
}